import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApixuService {

  constructor(private http: HttpClient) { }

  getWeather(location) {
    return this.http.get(
      'https://api.apixu.com/v1/current.json?key=ca5bcc4d82e676080c5c32ede50fc024&q=' + location
    );
  }
}
